import { Button } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import {
  EXP_SIGNUP_MODAL_SHARE_PAGE,
  ROLLOUT_SIGNUP_MODAL_FROM_SHARE_PAGE,
} from 'constants/featureFlag';
import { SIGNUP_MODAL } from 'constants/modalTypes';
import { SIGNUP_PAGE } from 'constants/routes';
import * as analytics from 'utilities/analytics';
import { isMobile } from 'utilities/device';
import { getFlagValueForUser } from 'utilities/featureFlag';

export default function SignupButton({
  forceSignupLink,
  tracking,
  size,
  isMainVideoOnSharePage,
  ctaAndValuePropFlagValue,
}) {
  const dispatch = useDispatch();

  const signupOnClick = async () => {
    analytics.track(tracking.eventName, tracking.properties);

    const showSignupModal = await getFlagValueForUser(
      ROLLOUT_SIGNUP_MODAL_FROM_SHARE_PAGE
    );

    if (isMobile || forceSignupLink) {
      // Embededed Looms should open the Signup page in a new tab
      // Shared Looms should open the Signup page in the same tab
      if (!isMainVideoOnSharePage) {
        window.open(SIGNUP_PAGE);
      } else {
        window.location.href = SIGNUP_PAGE;
      }
    } else {
      const experimentShowModal = await getFlagValueForUser(
        EXP_SIGNUP_MODAL_SHARE_PAGE
      );

      if (showSignupModal && experimentShowModal === 'variant') {
        dispatch(openModal(SIGNUP_MODAL, { signupMode: true }));
      } else {
        window.location.href = SIGNUP_PAGE;
      }
    }
  };

  let ctaText = 'Get Loom for Free';

  if (ctaAndValuePropFlagValue === 'variant-2') {
    ctaText = 'Start recording now';
  }

  return (
    <Button onClick={signupOnClick} size={size} variant="primary">
      {ctaText}
    </Button>
  );
}
